import {CommonModule, NgIf} from '@angular/common';
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {LanguageService} from "../../services/language.service";

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, NgIf, TranslateModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css'
})
export class DialogComponent implements OnInit {
  protected visible: boolean;
  @Input() title: string = "";
  @Input() content: string = "";
  @Output() onResult = new EventEmitter<boolean>();

  constructor(private translations: LanguageService) {
  }

  async ngOnInit() {
    this.visible = true;
    this.title = await this.translations.translate(this.title);
    this.content = await this.translations.translate(this.content);
  }

  protected confirm() {
    this.visible = false;
    this.onResult.emit(true);
  }

  protected close() {
    this.visible = false;
    this.onResult.emit(false);
  }

}
